import { useCallback, useEffect, useRef, useState } from "react";

// Amorce visuelle de défilement : il existera toujours une largeur où le tableau déborde,
// et rien n'indiquait qu'il fallait faire défiler. Le dégradé n'apparaît que s'il reste
// du contenu à droite, et disparaît dès qu'on atteint le bout.
export function ScrollableTable({ children, className = "", ...rest }) {
  const ref = useRef(null);
  const [reste, setReste] = useState(false);

  const mesurer = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setReste(el.scrollWidth - el.clientWidth - el.scrollLeft > 1);
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    mesurer();
    // Deuxième mesure différée : les données du tableau arrivent après le premier rendu
    const t = setTimeout(mesurer, 400);
    el.addEventListener("scroll", mesurer, { passive: true });
    window.addEventListener("resize", mesurer);
    const ro = new ResizeObserver(mesurer);
    ro.observe(el);
    if (el.firstElementChild) ro.observe(el.firstElementChild);
    // Les lignes arrivent après le premier rendu : on remesure à chaque changement du tableau
    const mo = new MutationObserver(mesurer);
    mo.observe(el, { childList: true, subtree: true });
    return () => {
      clearTimeout(t);
      el.removeEventListener("scroll", mesurer);
      window.removeEventListener("resize", mesurer);
      ro.disconnect();
      mo.disconnect();
    };
  }, [mesurer]);

  return (
    <div className="relative" data-testid="scrollable-table">
      <div ref={ref} className={className} {...rest}>{children}</div>
      {reste && (
        <div
          className="pointer-events-none absolute top-0 right-0 h-full w-10 bg-gradient-to-l from-slate-900/15 to-transparent"
          data-testid="scroll-hint"
          aria-hidden="true"
        />
      )}
    </div>
  );
}
